// extracted by mini-css-extract-plugin
export default {"cls1":"CoreXNav-cls1___c8712db37f5efbf3cf1","cls2":"CoreXNav-cls2___222014f9a92f80cdbcc CoreXNav-cls1___c8712db37f5efbf3cf1"};